/* eslint-disable no-nested-ternary */
import {
  DemandDetailWDH,
  DemandDetailEntity,
} from 'utils/__interfaces/MyDemands/DemandEntity'
import { formatDate } from 'utils/Common/date-utils'
import status from 'utils/MyDemands/demand-utils'
import EnumDemandStatus from 'utils/__enums/MyDemands/demandStatus'

class DemandDetailNormalizer {
  static normalize(demand: DemandDetailWDH): DemandDetailEntity {
    const plannedDate = demand.dateFinPlanification
      ? demand.dateFinPlanification
      : demand.dateDebutPlanification

    const statutECE = status(
      demand.statut.valueECE,
      plannedDate,
      demand.transco.demandMotif.label
    )

    return {
      crm: demand.typeCrm,
      id: demand.id,
      numDemand: demand.numDemand ? String(demand.numDemand) : '',
      address: `${demand.etsPresteAdresse} ${demand.etsPresteCode} ${demand.etsPresteVille}`,
      creationDate: formatDate(demand.createdAt, 'DD/MM/YYYY'),
      closedDate: formatDate(demand.dateCloturee, 'DD/MM/YYYY'),
      status: statutECE,
      statusCodeECE:
        statutECE === EnumDemandStatus.PLANIFIE
          ? 'PLANIFIE'
          : demand.statut.codeECE,
      motif: demand.transco.demandMotif.label,
      category: demand.transco.demandCategory.label,
      crmDetail: demand.transco.crmDetail,
      dossier: demand.numDossier,
      materiel: demand.materiel,
      dechet: demand.dechet,
      expectedDate: demand.dateSouhaitee
        ? formatDate(demand.dateSouhaitee, 'DD/MM/YYYY')
        : '-',
      startPlannedDate: demand.dateDebutPlanification
        ? formatDate(demand.dateDebutPlanification, 'DD/MM/YYYY')
        : '-',
      endPlannedDate: demand.dateFinPlanification
        ? formatDate(demand.dateFinPlanification, 'DD/MM/YYYY')
        : demand.dateDebutPlanification
        ? formatDate(demand.dateDebutPlanification, 'DD/MM/YYYY')
        : '-',
      description: demand.description,
      comments: demand.demandComments,
      files: demand.files,
      userFirstName: demand.userECE.firstname,
      userLastName: demand.userECE.lastname,
    }
  }
}

export default DemandDetailNormalizer
